/**
 * This mixin is for components that are tightly coupled to their parent; they do
 * not declare props but dynamically bind to data passed down from the parent via
 * $attrs. When values are updated in the child, an "update" event is automatically
 * emitted with the prop name and value. Works particularly well when the parent uses
 * "v-bind=" with or without the ".sync" modifier.
 *
 * An example where this pattern is useful is splitting up a large form into smaller
 * child forms, which would normally necessitate declaring redundant props and forgoing
 * the convenience of using v-model in the child components in favor of tediously
 * binding the value and emitting the proper update event for each field.
 */
export default {
  // Since the bound attributes are used to generate computed properties (below),
  // don't apply them to the root element
  inheritAttrs: false,

  beforeCreate() {
    this.$options.computed = {
      ...this.$options.computed,
      ...Object.keys(this.$attrs).reduce((result, key) => ({
        ...result,
        [key]: {
          get() {
            return this.$attrs[key];
          },
          set(val) {
            this.$emit(`update:${key}`, val);
          }
        }
      }), {})
    };
  }
};
